import PropTypes from "prop-types";
import { Box, Typography, Stack } from "@mui/material";
import AuthShell from "../../components/NewLogin/AuthShell";
import AuthFormWrapper from "../../components/NewLogin/AuthFormWrapper";
import AuthTransition from "../../components/NewLogin/AuthTransition";
import BackToLogin from "../../components/NewLogin/BackToLogin";
import { FONT, FONT_REGULAR } from "../../components/NewLogin/authStyles";
import images from "../../constant/images";
import { useTranslation } from "react-i18next";

/**
 * EmailSentPage
 * Shown after a successful password reset request.
 *
 * Props:
 *   onBackToLogin – () => void
 */
const EmailSentPage = ({ onBackToLogin }) => {
  const { t } = useTranslation();
  return (
    <AuthShell isLoading>
      <AuthFormWrapper maxWidth={300}>
        <AuthTransition>
          {/* ── SCAI logo + heading ── */}
          <Stack alignItems="center" spacing="0.276rem" sx={{ mb: "1.857rem" }} gap={"1.429rem"}>
            <Box component="img" src={images.SCAI} />

            <Stack alignItems="center" spacing="0.276rem">
              <Typography
                sx={{
                  fontFamily: FONT,
                  fontSize: "1.8rem",
                  fontWeight: 400,
                  lineHeight: "1.857rem",
                  color: "#07080B",
                  textAlign: "center",
                }}
              >
                {t("HEY_WE_GOT_YOUR_BACK")} 😎
              </Typography>
              <Typography
                sx={{
                  fontFamily: FONT_REGULAR,
                  fontSize: "1.143rem",
                  fontWeight: 300,
                  lineHeight: "1.714rem",
                  color: "#474849",
                  textAlign: "center",
                  width: "100%",
                }}
              >
                {t("IF_YOUR_EMAIL_IS_REGISTERED")}
                <br />
                {t("PLEASE_CHECK_INBOX")}
              </Typography>
            </Stack>
          </Stack>

          {/* ── Back to login ── */}
          <BackToLogin onBackToLogin={onBackToLogin} />
        </AuthTransition>
      </AuthFormWrapper>
    </AuthShell>
  );
};

EmailSentPage.propTypes = {
  onBackToLogin: PropTypes.func,
};

export default EmailSentPage;
